import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { FastighetGeometry } from "./map-fastighet-models";

// Delar fastighetshistorik mellan kartor/dialoger som har egna MapFastighetService-instanser
@Injectable({ providedIn: "root" })
export class AvtalFastigheterStore {
    private readonly fastigheterSrc = new BehaviorSubject<FastighetGeometry[]>([]);

    get fastigheter$() { return this.fastigheterSrc.asObservable(); }

    add(fastighet: FastighetGeometry): void {
        const current = this.fastigheterSrc.value;
        if (!current.some(f => f.geometry.id === fastighet.geometry.id)) {
            this.fastigheterSrc.next([
                ...current,
                fastighet
            ]);
        }
    }
}
